<lib-main-layout systemName="Clearing">
  <ng-template #navigationTemplate let-isSidebarCollapsed="isSidebarCollapsed">
    <div class='app-nav-stack h-full'>
    <ul class='app-nav-group list-none p-3 m-0'>
          <li>
            <a pRipple routerLink=''
               [pTooltip]="('navigation.dashboard' | translate)"
               [tooltipDisabled]="!isSidebarCollapsed"
               tooltipStyleClass='app-sidebar-tooltip'
               tooltipPosition='right'
               appendTo='body'
               class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
              class='pi pi-home mr-2'></i><span class='font-medium'>{{ 'navigation.dashboard' | translate }}</span>
            </a>
          </li>
          <li class='app-nav-mini-divider mx-2 my-2'></li>

          <li><a pRipple routerLink='tickets/inbox'
                 [pTooltip]="('navigation.inbox' | translate)"
                 [tooltipDisabled]="!isSidebarCollapsed"
                 tooltipStyleClass='app-sidebar-tooltip'
                 tooltipPosition='right'
                 appendTo='body'
                 class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
            class='pi pi-inbox mr-2'></i><span class='font-medium'>{{ 'navigation.inbox' | translate }}</span><span
            class='menu-count app-menu-count inline-flex align-items-center justify-content-center ml-auto'
            style='min-width: 1.5rem; height: 1.5rem;'>{{ totalInbox }}</span><span class='p-ink'></span></a>
          </li>
          <li><a pRipple routerLink='tickets/outbox'
                 [pTooltip]="('navigation.outbox' | translate)"
                 [tooltipDisabled]="!isSidebarCollapsed"
                 tooltipStyleClass='app-sidebar-tooltip'
                 tooltipPosition='right'
                 appendTo='body'
                 class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
            class='pi pi-send mr-2'></i><span class='font-medium'>{{ 'navigation.outbox' | translate }}</span><span
            class='menu-count app-menu-count inline-flex align-items-center justify-content-center ml-auto'
            style='min-width: 1.5rem; height: 1.5rem;'>{{ totalOutbox }}</span><span class='p-ink'></span></a>
          </li>
          <li><a pRipple routerLink='tickets/myIssues'
                 [pTooltip]="('navigation.my_issues' | translate)"
                 [tooltipDisabled]="!isSidebarCollapsed"
                 tooltipStyleClass='app-sidebar-tooltip'
                 tooltipPosition='right'
                 appendTo='body'
                 class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
            class='pi pi-list-check mr-2'></i><span
            class='font-medium'>{{ 'navigation.my_issues' | translate }}</span><span
            class='menu-count app-menu-count inline-flex align-items-center justify-content-center ml-auto'
            style='min-width: 1.5rem; height: 1.5rem;'>{{ totalMyIssues }}</span></a>
          </li>
          <li><a pRipple routerLink='tickets/watchingIssues'
                 [pTooltip]="('navigation.watching' | translate)"
                 [tooltipDisabled]="!isSidebarCollapsed"
                 tooltipStyleClass='app-sidebar-tooltip'
                 tooltipPosition='right'
                 appendTo='body'
                 class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
            class='pi pi-eye mr-2'></i><span class='font-medium'>{{ 'navigation.watching' | translate }}</span><span
            class='menu-count app-menu-count inline-flex align-items-center justify-content-center ml-auto'
            style='min-width: 1.5rem; height: 1.5rem;'>{{ totalWatchingIssues }}</span></a>
          </li>
          <li class='app-nav-mini-divider mx-2 my-2'></li>


          <li>
            <a pRipple [routerLink]='createTicketRoute'
               [pTooltip]="('navigation.create_new' | translate)"
               [tooltipDisabled]="!isSidebarCollapsed"
               tooltipStyleClass='app-sidebar-tooltip'
               tooltipPosition='right'
               appendTo='body'
               class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
              class='pi pi-plus-circle mr-2'></i><span
              class='font-medium'>{{ 'navigation.create_new' | translate }}</span><span
              class='p-ink'></span></a>
          </li>
          <li>
            <a pRipple [routerLink]='templatesRoute'
               [pTooltip]="('navigation.select_template' | translate)"
               [tooltipDisabled]="!isSidebarCollapsed"
               tooltipStyleClass='app-sidebar-tooltip'
               tooltipPosition='right'
               appendTo='body'
               class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
              class='pi pi-copy mr-2'></i><span
              class='font-medium'>{{ 'navigation.select_template' | translate }}</span>
            </a>
          </li>
    </ul>
    <div class='app-nav-divider app-nav-divider--secondary mx-3'></div>
    <ul class='app-nav-group app-nav-group--secondary list-none p-3 m-0'>

          <li *ngIf='canManageSettings'><a pRipple pStyleClass='@next' enterFromClass='hidden' enterActiveClass='slidedown'
                 leaveToClass='hidden' leaveActiveClass='slideup'
                 (click)='toggleSettingsMenu()'
                 [pTooltip]="('navigation.settings' | translate)"
                 [tooltipDisabled]="!isSidebarCollapsed"
                 tooltipStyleClass='app-sidebar-tooltip'
                 tooltipPosition='right'
                 appendTo='body'
                 class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
            class='pi pi-cog mr-2'></i><span class='font-medium'>{{ 'navigation.settings' | translate }}</span><i
            class='pi pi-chevron-down ml-auto app-nav-chevron'
            [class.app-nav-chevron-expanded]='settingsExpanded'></i>
            <span class='p-ink' style='height: 247px; width: 247px; top: -94.5px; left: 5.5px;'></span></a>
            <ul
              class='list-none py-0 pl-3 pr-0 m-0 overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out hidden'>
              <li><a pRipple routerLink='settings/partner-config'
                     [pTooltip]="('navigation.partnership' | translate)"
                     [tooltipDisabled]="!isSidebarCollapsed"
                     tooltipStyleClass='app-sidebar-tooltip'
                     tooltipPosition='right'
                     appendTo='body'
                     class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
                class='pi pi-users mr-2'></i><span
                class='font-medium'>{{ 'navigation.partnership' | translate }}</span><span
                class='p-ink'></span></a>
              </li>
              <li><a pRipple routerLink='settings/roles'
                     [pTooltip]="('navigation.role_management' | translate)"
                     [tooltipDisabled]="!isSidebarCollapsed"
                     tooltipStyleClass='app-sidebar-tooltip'
                     tooltipPosition='right'
                     appendTo='body'
                     class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
                class='pi pi-id-card mr-2'></i><span
                class='font-medium'>{{ 'navigation.role_management' | translate }}</span><span
                class='p-ink'></span></a>
              </li>
              <li><a pRipple routerLink='settings/routing/inbox'
                     [pTooltip]="('navigation.inbox_routing' | translate)"
                     [tooltipDisabled]="!isSidebarCollapsed"
                     tooltipStyleClass='app-sidebar-tooltip'
                     tooltipPosition='right'
                     appendTo='body'
                     class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
                class='pi pi-directions app-nav-routing-icon app-nav-routing-icon--outbox mr-2'></i><span
                class='font-medium'>{{ 'navigation.inbox_routing' | translate }}</span><span
                class='p-ink'></span></a>
              </li>
              <li><a pRipple routerLink='settings/routing/outbox'
                     [pTooltip]="('navigation.outbox_routing' | translate)"
                     [tooltipDisabled]="!isSidebarCollapsed"
                     tooltipStyleClass='app-sidebar-tooltip'
                     tooltipPosition='right'
                     appendTo='body'
                     class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
                class='pi pi-directions app-nav-routing-icon app-nav-routing-icon--inbox mr-2'></i><span
                class='font-medium'>{{ 'navigation.outbox_routing' | translate }}</span><span
                class='p-ink'></span></a>
              </li>
              <li><a pRipple routerLink='settings/sla'
                     [pTooltip]="('navigation.sla_config' | translate)"
                     [tooltipDisabled]="!isSidebarCollapsed"
                     tooltipStyleClass='app-sidebar-tooltip'
                     tooltipPosition='right'
                     appendTo='body'
                     class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
                class='pi pi-sliders-v mr-2'></i><span
                class='font-medium'>{{ 'navigation.sla_config' | translate }}</span><span
                class='p-ink'></span></a>
              </li>
            </ul>
          </li>

          <li><a pRipple routerLink='help'
                 [pTooltip]="('navigation.help' | translate)"
                 [tooltipDisabled]="!isSidebarCollapsed"
                 tooltipStyleClass='app-sidebar-tooltip'
                 tooltipPosition='right'
                 appendTo='body'
                 class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
            class='pi pi-question-circle mr-2'></i><span
            class='font-medium'>{{ 'navigation.help' | translate }}</span><span class='p-ink'></span></a>
          </li>

          <li *ngIf='canSeeMigration'><a pRipple routerLink='migration'
                 [pTooltip]="('navigation.migration' | translate)"
                 [tooltipDisabled]="!isSidebarCollapsed"
                 tooltipStyleClass='app-sidebar-tooltip'
                 tooltipPosition='right'
                 appendTo='body'
                 class='p-ripple p-element flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors'><i
            class='pi pi-sync mr-2'></i><span
            class='font-medium'>{{ 'navigation.migration' | translate }}</span><span class='p-ink'></span></a>
          </li>
    </ul>
    </div>
  </ng-template>
  <ng-template #userTemplate>
    <li (click)='notificationsPanel.toggle($event)'>
      <a pRipple
         class='p-ripple p-element flex lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer
           transition-duration-150 transition-colors'>
        <i class='p-element pi pi-bell text-base lg:text-2xl mr-2 lg:mr-0'
           [class.p-overlay-badge]='notificationsMenuItems.length > 0'>
          <span *ngIf='notificationsMenuItems.length > 0' class='p-badge p-component p-badge-dot p-badge-danger'></span>
        </i>
        <p-overlayPanel [style]="{ minWidth: '20vw', maxHeight: '30vh', overflowY: 'auto' }" #notificationsPanel>
          <div class='notifications-container'>
            <ng-container
              *ngTemplateOutlet='notificationsMenuItems.length ? notificationsContent : noNotifications'></ng-container>
          </div>
          <ng-template #notificationsContent>
            <p-menu class='notifications-menu' [style]="{ width: '100%', paddingTop: '0px', paddingBottom: '40px'}"
                    [model]='notificationsMenuItems'>
            </p-menu>
            <div (click)='this.markAllUserSentNotificationsAsRead()' class='mark-all-read'>
              <label class='mark-all-read-label'>{{ 'mark_all_as_read' | translate }}</label>
            </div>
          </ng-template>
          <ng-template #noNotifications>
            <div class='m-4'>
              <label class='font-medium text-900'>{{ 'no_notifications' | translate }}</label>
            </div>
          </ng-template>
        </p-overlayPanel>
      </a>
    </li>
  </ng-template>
</lib-main-layout>
